<template>
  <div id="code-preview" class="shadow w-full bg-card">
    <div class="previewer h-full flex items-center justify-center">
      <div class="preview-window-actions">
        <div
          v-if="isMaximized"
          @click="$emit('minimize')"
          class="window-minimize"
        >
          <v-mdi name="mdi-window-minimize" size="18"  />
        </div>
        <div
          v-else
          @click="$emit('maximize')"
          class="window-maximize"
        >
          <v-mdi name="mdi-crop-free" size="18" />
        </div>
      </div>
      <iframe
        id="previewIframe"
        :srcDoc="srcDoc"
        class="w-full h-full bg-white"
        title="output"
        sandbox="allow-scripts allow-downloads allow-forms allow-modals allow-pointer-lock allow-popups allow-presentation allow-same-origin allow-top-navigation-by-user-activation"
        frameBorder="0"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodePreviewComponent',
  props: {
    previews: Object,
    isMaximized: Boolean,
  },
  data() {
    return {
      srcDoc: ''
    }
  },
  methods: {
    updateIframePreview (previews) {
      const { html, css, js } = previews
      this.srcDoc = `<html lang="fr"><body>${html}</body><style>${css}</style><script>${js}<\/script></html>`
    }
  },
  mounted() {
    this.updateIframePreview(this.previews)
  },
  watch: {
    previews: {
      handler (newPreviews) {
        if (newPreviews) {
          this.updateIframePreview(newPreviews)
        }
      },
      deep: true
    }
  },
}
</script>

<style scoped>

</style>
